module.exports = __webpack_public_path__ + "img/3.2689154a.jpg";